import {Button} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Link} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {authState} from '../../store/auth/atoms';
import {TypeAccountRoles} from '../../shared/types/user-account.types';
import {readyReports} from '../../modules/report-builder/constants/ready-reports';
import {useReportPermissions} from '../../modules/report-builder/hooks/use-report-permissions';
import styles from '../../modules/report-builder/report-pages.module.scss';

const ReportsPage = () => {
  const {user} = useRecoilValue(authState);
  const {canView} = useReportPermissions();
  const isCustomer = user?.roles?.filter((role) => role !== TypeAccountRoles.CUSTOMER).length === 1;
  return (
    <section className={styles.page} aria-labelledby="ready-reports-title">
      <header className={styles.heading}>
        <div>
          <h1 id="ready-reports-title">Готовые отчёты</h1>
          <p>Выберите нужный отчёт или создайте новый</p>
        </div>
        {canView && (
          <Button
            component={Link}
            to="/reports/builder"
            variant="contained"
            disableElevation
            sx={{textTransform: 'none', flexShrink: 0}}
          >
            Конструктор отчётов
          </Button>
        )}
      </header>
      <div className={styles.grid}>
        {readyReports
          .filter((report) => !report.internal || !isCustomer)
          .map((report) => (
            <Link key={report.path} className={styles.readyCard} to={`/reports/${report.path}`}>
              <span className={styles.reportIcon} style={{backgroundColor: report.color}}>
                <img src={report.icon} alt="" />
              </span>
              <h2>{report.name}</h2>
              <p className={styles.description}>{report.description}</p>
              <span className={styles.arrow} aria-hidden="true">
                <ArrowForwardIcon sx={{fontSize: 20}} />
              </span>
            </Link>
          ))}
      </div>
    </section>
  );
};

export default ReportsPage;
